import React from 'react';
import * as Yup from 'yup';
import { Form, Formik } from 'formik';
import { TextAreaField } from "./settings-form/elements";


const validationSchema = Yup.object().shape({
  settings: Yup.string()
    .required(`Can't be blank`)
    .test('is-json', 'Must be valid JSON', (value) => {
      if (!value) return true;
      try {
        JSON.parse(value);
        return true;
      } catch {
        return false;
      }
    }),
});

export default function ImportSettingsForm({submitHandler, defaultValues}) {
  return (
    <div className='nv-chart-settings'>
      <Formik
        initialValues={defaultValues}
        validationSchema={validationSchema}
        onSubmit={values => submitHandler(values)}>
        {({values}) => {
          return (
            <Form>
              <div>
                <div className='nv-chart-settings-form__field'>
                  <div className='form-section'>
                    <div className='row'>
                      <div className='col-12'>
                        <TextAreaField name='settings' label={null} rows={10}/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='form-actions'>
                <button type='submit' className='btn btn-info btn-sm mt-3 mb-1'>Import settings</button>
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
}
